import React from "react";
import classNames from "classnames";

import Props from "./types";

import styles from "./section.module.css";

const SettingsSection = ({
  bgColor = "var(--colorWhite)",
  children,
  maxWidth,
}: Props): JSX.Element => {
  return (
    <div className={styles.bgContainer}>
      <div
        className={styles.settingsSection}
        style={maxWidth && { maxWidth: maxWidth }}
      >
        {children}
      </div>
    </div>
  );
};

export default SettingsSection;
